import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";

export const Tab = ({
  title,
  onSelect,
  active,
  className,
}: {
  title: string | ReactNode;
  onSelect: () => void;
  active: boolean;
  className?: string;
}) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={cn(
        "select-none focus:outline-blue whitespace-nowrap rounded-3xl pr-3 capitalize transition-all focus:outline-1 sm:pr-5",
        active && "font-bold underline",
        className,
      )}
    >
      {title}
    </button>
  );
};
